import { render } from "./ico-arrow-left.vue?vue&type=template&id=1a103270"
const script = {}

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__